import React, { useEffect, useState } from "react";
import { ChevronDown, ChevronRight, Wallet } from "lucide-react";
import { api, fmtDate } from "@/lib/api";

export const PendingSalaryPanel = ({ refreshKey, isAdmin, onEdit }) => {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(true);
  useEffect(() => { api.get("/personnel/pending-salary").then((r) => setRows(r.data.rows)).catch(() => {}); }, [refreshKey]);
  if (!rows.length) return null;
  const unread = rows.filter((r) => r.unread).length;

  return (
    <div className="mx-4 md:mx-5 mt-3 border border-orange-300 bg-orange-50 rounded-lg" data-testid="pending-salary-panel">
      <button type="button" onClick={() => setOpen(!open)} data-testid="pending-salary-toggle"
        className="w-full flex items-center gap-2 px-3 py-2 text-left text-sm font-semibold text-orange-900">
        <Wallet size={15} className="text-orange-700" />
        <span data-testid="pending-salary-count">{rows.length} personelin maaşı bekleniyor</span>
        {unread > 0 && <span className="text-[10px] font-bold px-1.5 py-0.5 rounded-full bg-rose-600 text-white" data-testid="pending-salary-unread">{unread} yeni bildirim</span>}
        <span className="text-[11px] font-normal text-orange-700">· {isAdmin ? "maaş girilene kadar banka listesine alınmaz" : "Admin maaşı girince banka listesine alınır"}</span>
        <span className="ml-auto">{open ? <ChevronDown size={15} /> : <ChevronRight size={15} />}</span>
      </button>
      {open && (
        <div className="px-3 pb-3 space-y-1.5">
          {rows.map((p) => (
            <div key={p.id} className="flex items-center gap-2 bg-white border border-orange-200 rounded-md px-2 py-1.5" data-testid={`pending-salary-row-${p.sicil_no}`}>
              {p.unread && <span className="w-2 h-2 rounded-full bg-rose-600 shrink-0" />}
              <div className="flex-1 min-w-0">
                <div className="text-sm font-semibold text-slate-900">{p.ad_soyad}</div>
                <div className="text-[11px] text-slate-500">{p.pozisyon} · işe başlama {fmtDate(p.ise_baslama_tarihi)}{p.added_by ? ` · ekleyen: ${p.added_by}` : ""}</div>
              </div>
              {isAdmin && (
                <button onClick={() => onEdit(p)} data-testid={`pending-salary-edit-${p.sicil_no}`}
                  className="px-2.5 py-1 bg-orange-600 hover:bg-orange-700 text-white rounded text-xs font-semibold">Maaş Gir</button>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
